export default [
  {
    path: '/organizations',
    meta: { auth: 'administrator' },
    component: () => import(/* webpackChunkName: 'organizations-list' */ '@/views/organizations/List.vue')
  }, {
    path: '/organizations/new',
    meta: { auth: 'administrator' },
    component: () => import(/* webpackChunkName: 'organizations-create' */ '@/views/organizations/Create.vue')
  }, {
    path: '/organizations/:id',
    meta: { auth: 'administrator' },
    component: () => import(/* webpackChunkName: 'organization-page' */ '@/views/organizations/Organization.vue')
  }
]
